module.exports = __webpack_public_path__ + "static/media/baseMeme14thumb.3866721a.jpg";